'use client';

import a__default from "react";
import { Text } from "../../atoms/Text/Text.js";
import { FakeOption } from "./Select.FakeOption.js";
import { optionContent } from "./Select.css.js";
function Empty({
  emptyLabel,
  isLoading,
  noOptionsProvided
}) {
  return !isLoading && noOptionsProvided && /* @__PURE__ */ a__default.createElement(FakeOption, null, /* @__PURE__ */ a__default.createElement("div", { className: optionContent }, /* @__PURE__ */ a__default.createElement(Text, { color: "onLight.text.tertiary", variant: "body.base" }, emptyLabel)));
}
export {
  Empty
};
